document.addEventListener('DOMContentLoaded', function () {

  // Skip on mobile for performance
  if (window.innerWidth <= 768) return;

  const sections = document.querySelectorAll('.image-with-controls-new');
  if (!sections.length) return;

  sections.forEach(section => {
    const container = section.querySelector('.image-container-new');
    const positionDataInput = section.querySelector('.position-data-new');
    const moveButtons = section.querySelectorAll('.move-button-new');

    if (!container || !positionDataInput || !moveButtons.length) return;

    let currentPosition = positionDataInput.value.split(' ');
    if (currentPosition.length !== 2) {
      currentPosition = ['center', 'center'];
    }

    container.style.backgroundPosition = currentPosition.join(' ');
    positionDataInput.value = currentPosition.join(' ');

    moveButtons.forEach(button => {
      button.addEventListener('click', function () {
        const dir = this.dataset.direction;

        if (dir === 'left' || dir === 'right') currentPosition[0] = dir;
        if (dir === 'top' || dir === 'bottom') currentPosition[1] = dir;

        requestAnimationFrame(() => {
          container.style.backgroundPosition = currentPosition.join(' ');
          positionDataInput.value = currentPosition.join(' ');
        });
      });
    });
  });

});
